import get from 'lodash/get'
import { ICarrierCallListMatchStrategyEnum } from 'types/graphqlTypes'
import { getTimeAgoShort } from 'utils/formatDatetime'
import { CARRIER_STATUS_ICON_MAP, TCarrierStatusIcons } from './constants'
import { MATCH_LABELS, MATCH_STYLES, TMatchLabels, TMatchStyles } from './types'

/**
 * Returns the ICarrierCallListMatchStrategyEnum given a key string
 * @example getMatchEnum('posted_truck') // ICarrierCallListMatchStrategyEnum.posted_truck
 */
export function getMatchEnum(keyName: string): ICarrierCallListMatchStrategyEnum {
  return get(ICarrierCallListMatchStrategyEnum, keyName)
}

/**
 * Grabs the tag style based on the match type
 * @example getMatchStyle(ICarrierCallListMatchStrategyEnum.posted_truck) // TAG_STYLE.accentGreen
 */
export function getMatchStyle<K extends ICarrierCallListMatchStrategyEnum>(
  matchType: K
): TMatchStyles[K] {
  return MATCH_STYLES[matchType]
}

/**
 * Grabs the tag style based on the match type
 * @example getMatchLabel(ICarrierCallListMatchStrategyEnum.posted_truck) // 'Posted Trucks'
 */
export function getMatchLabel<K extends ICarrierCallListMatchStrategyEnum>(
  matchType: K
): TMatchLabels[K] {
  return MATCH_LABELS[matchType]
}

type TIconKey = keyof TCarrierStatusIcons

/**
 * Returns component and color
 * @example getStatusIcon('active') // { Icon: CheckFilled, color: 'success' }
 */
export function getStatusIcon<K extends TIconKey>(keyName: K): TCarrierStatusIcons[K] {
  return CARRIER_STATUS_ICON_MAP[keyName]
}

/**
 * Generates label based on props
 * @example getMatchStrategyLabel('Posted Truck', '2020-12-19T:11:30:00Z') // 'Posted Truck - 2d ago'
 */
export const getMatchStrategyLabel = (
  matchLabel: ICarrierCallListMatchStrategyEnum,
  datetime?: string | null
): string => {
  let label: string = getMatchLabel(matchLabel)
  if (datetime && matchLabel === ICarrierCallListMatchStrategyEnum.posted_truck) {
    const timeAgo = getTimeAgoShort(datetime, { minute: 'm' })
    label += ` · ${timeAgo}`
  }
  return label
}
